<template>
  <div>
    <el-row :gutter="24" v-loading="load" class="box-card">
      <el-col :xs="24">
        <div class="content-box__subtitle">Состояние здоровья (Метод не реализован)</div>
        <el-tabs v-model="activeName">
          <el-tab-pane
              :label="index"
              :name="'item'+index"
              v-for="index in tabData.data"
              :key="index"
          >
            <el-row>
              <el-input
                  disabled
                  type="textarea"
                  v-model="tabData.data[index]"
                  :rows="4"
                  :placeholder="index"
              ></el-input>
            </el-row>
          </el-tab-pane>
        </el-tabs>

        <el-row :gutter="5" class="content-box__btns">
          <el-button type="primary" @click="submitCard">Выйти</el-button>
        </el-row>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "visit.state",
  data() {
    return {
      activeName: "itemphys",
      load: !!1,
      tabData: {},
      nowDate: new Date(),
    };
  },
  computed: {
    visit() {
      return this.$route.params.visit;
    },
  },
  created() {
    if (this.visit) this.loadLogic();
    else this.$router.push({ name: "visit.list" });
  },
  methods: {
    ...mapActions({
      setStageVisit: "visit/SET_STAGE"
    }),
    loadLogic() {
      this.load = true;
      this.$api.visit
          .getRecommendation(this.visit.id)
          .then((response) => {
            this.tabData = response.data;
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.load = false;
          });
    },
    submitCard() {
      this.$router.push({
        name: "visit.list"
      });
    },
    goBack() {
      this.$router.push({
        name: "visit.device",
        params: { id: this.visit.id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.content-box {
  &__subtitle {
    margin: 0 0 20px 0;

    font-weight: bold;
    font-size: 16px;
    line-height: 34px;
    color: #333;
  }

  &__btns {
    margin: 50px 0 0 0;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    display: inline-block;
    font-weight: bold;
    font-size: 30px;
    line-height: 38px;
    color: #333;
    margin: 0;
  }

  &__btn {
    font-size: 16px;
    line-height: 140%;
    color: #6c81a0;
  }
}
</style>
